// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"a777e712","118":"dd315bbf","135":"f61452e1","210":"3dfd1331","235":"37484265","306":"fa4dd38b","403":"9e7cb4f2","507":"1dffb7cc","844":"69d8874d"}[chunkId] + ".chunk.js";
};